import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb3"
import { withTranslation } from "react-i18next"
import "../../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper"

// Services
import {
  CreateContent,
  GetContentById,
  UpdateContent,
} from "./services/Services.js"

// import {
//   SearchPageSetting,
//   SearchPageDetail,
//   SavePageDetail,
//   UpdatePageDetail,
// } from "../../../services/api/module/PageSetting.js"

import configWebRoute from "services/api/configWebRoute"
import LinkOut from "pages/newPage/component/LinkOut"
import {
  SavePageDetail,
  SearchPageSetting,
  UpdatePageDetail,
  SearchPageDetail,
} from "services/api/module/PageSetting"
import Error401 from "components/Error401"
import { SearchContentCate } from "../Category/services/Services"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `flagship-project/list`
const _pageName = `Flagship Project`
const _parentComponent = configWebRoute.FLAGSHIP_PROJECT
const slugType = ""
const _routePermission = `flagship-project:flagship-project-list`

const FlagShipProjectDetailTemplate = ({
  pageView = "create",
  componentKey = "",
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = qParams.id
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)
  const [contentDetail, setContentDetail] = useState()
  const [pageDetail, setPageDetail] = useState()
  const [prefillComplete, setPrefillComplete] = useState()
  const [list, setList] = useState([])
  const [categoryList, setCategoryList] = useState([])

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentName: Yup.string().max(255).required("Please Enter Business name"),
    contentShowSustain: Yup.string().required(
      "Please Enter Content Show In Sustainability"
    ),
    categoryId: Yup.string().required("Please Select Category"),

    thumbnail: Yup.object()
      .test(
        "is-not-empty-object",
        "Please Upload Banner Desktop",
        value => value && Object.keys(value).length > 0
      )
      .required("Please Upload Image"),

    bannerDesktop: Yup.object()
      .test(
        "is-not-empty-object",
        "Please Upload Banner Desktop",
        value => value && Object.keys(value).length > 0
      )
      .required("Please Upload Banner Desktop"),

    bannerMobile: Yup.object()
      .test(
        "is-not-empty-object",
        "Please Upload Banner Mobile",
        value => value && Object.keys(value).length > 0
      )
      .required("Please Upload Banner Mobile"),

    contentUpdateDate: Yup.string()
      .max(100)
      .required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),

    contentSeoTitle: Yup.string(),
    contentSeoKeyword: Yup.string().max(1024),
    contentSeoDescription: Yup.string().max(1024),
    // gallery: Yup.object().test(
    //   "is-not-empty-object",
    //   "Please Upload Gallery",
    //   (value) => value && Array.isArray(value) && value.length === 0
    // ).required("Please Upload Gallery"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string()
    //   .max(1024)
    //   .required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string()
    //   .max(1024)
    //   .required("Please Enter Meta Description"),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentName: "",
    categoryId: "",
    contentDetail: "",
    contentShowSustain: "",
    contentShortDetail: "",
    titleDetail: "",
    descriptionHeader: "",
    bannerDesktop: {},
    bannerMobile: {},
    // gallery: [],
    thumbnail: {},
    icon: {},
    imageDescription: {},

    contentLinkout: "",
    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",

    slug: "",
    titleDetail: "",
    // contentPageName: "",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
      const payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        categoryId: values.categoryId ? values.categoryId : null,
        langId: qLang,
        contentName: values.contentName,
        contentDetail: values.contentDetail,
        contentShowSustain: values.contentShowSustain,
        titleDetail: values.titleDetail,
        contentShortDetail: values.contentShortDetail,
        descriptionHeader: values.descriptionHeader,
        // gallery: values.gallery,
        bannerMobile: values.bannerMobile,
        contentLinkout: values.contentLinkout ? values.contentLinkout : null,

        slug: values.slug ? values.slug.replace(/-+$/, "") : null,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {},
        contentAttachmentData: {},

        // pageSettingRoute: {
        //   contentPageName: values.contentPageName,
        //   componentKey: componentKey
        // }
      }

      const pageDetailRoute = {
        mainId: pageDetail?.data?.mainId,
        contentPageName: payload.contentName,
        slug: `${payload.slug}`,
        attachmentData: {},
        contentAttachmentData: {},
        contentSeoTitle: values.contentSeoTitle ? values.contentSeoTitle : null,
        contentSeoKeyword: values.contentSeoKeyword
          ? values.contentSeoKeyword
          : null,
        contentSeoDescription: values.contentSeoDescription
          ? values.contentSeoDescription
          : null,
        componentKey: componentKey,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,
        _parentComponent: _parentComponent,
      }

      // if (values.imageDescription) {
      //   payload.contentAttachmentData['imageDescription'] = values.imageDescription;
      // }
      if (values.bannerDesktop) {
        payload.contentAttachmentData["bannerDesktop"] = values.bannerDesktop
        pageDetailRoute.contentAttachmentData["bannerDesktop"] =
          values.bannerDesktop
      }
      if (values.bannerMobile) {
        payload.contentAttachmentData["bannerMobile"] = values.bannerMobile
        pageDetailRoute.contentAttachmentData["bannerMobile"] =
          values.bannerMobile
      }
      if (values.thumbnail) {
        payload.contentAttachmentData["thumbnail"] = values.thumbnail
      }
      if (values.icon) {
        payload.contentAttachmentData["icon"] = values.icon
      }

      console.log("🚀 ~ onSave ~ payload:", payload)

      setWaitSendData(true)
      if (pageView === "update") {
        // API.fetchUpdateContent(payload)
        API.fetchUpdateContent(payload, pageDetailRoute)
      } else {
        API.fetchCreateContent(payload, pageDetailRoute)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentName", resData?.contentName ?? "")

    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue(
      "contentShowSustain",
      resData?.contentShowSustain ?? ""
    )
    validation.setFieldValue(
      "contentShortDetail",
      resData?.contentShortDetail ?? ""
    )
    validation.setFieldValue("titleDetail", resData?.titleDetail ?? "")
    validation.setFieldValue("categoryId", resData?.categoryId ?? "")
    // validation.setFieldValue("descriptionHeader", resData?.descriptionHeader ?? "")
    // validation.setFieldValue("contentLinkout", resData?.contentLinkout ?? "")

    // validation.setFieldValue("gallery", resData?.gallery ?? [])

    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue(
      "contentSeoKeyword",
      resData?.contentSeoKeyword ?? ""
    )
    validation.setFieldValue(
      "contentSeoDescription",
      resData?.contentSeoDescription ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )
    validation.setFieldValue("slug", resData?.slug ?? "")

    // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")

    validation.setFieldValue(
      "thumbnail",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "thumbnail"
      ) ?? ""
    )
    validation.setFieldValue(
      "icon",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "icon"
      ) ?? ""
    )
    validation.setFieldValue(
      "imageDescription",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "image_description"
      ) ?? ""
    )
    validation.setFieldValue(
      "bannerDesktop",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_desktop"
      ) ?? ""
    )
    validation.setFieldValue(
      "bannerMobile",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_mobile"
      ) ?? ""
    )

    setContentDetail(resData)
    setPrefillComplete(true)
  }

  // const preFilInputPage = (resData = {}) => {
  //   console.log("🚀 ~ preFilInputPage ~ resData:", resData)
  //   // resetForm(validation.values, initialValues)

  //   validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
  //   validation.setFieldValue("slug", resData?.slug ?? "")
  // }

  const API = {
    fetchGetPageDetail: async (componentKey, slug) => {
      const response = await SearchPageDetail(componentKey, {
        lang: qLang,
        params: {
          slug: slug,
        },
      })
      const resData = response.data
      if (resData.status == 200) {
        setPageDetail(resData.data)
      }
    },
    fetchGetContentPageSetting: async componentKey => {
      try {
        const response = await SearchPageSetting(componentKey, {
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          console.log("KZKB", resData.data)
          preFilInputPage(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchGetContentById: async payload => {
      try {
        const response = await GetContentById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async (payload, pageDetailRoute) => {
      try {
        let responseP = {
          status: 201,
        }

        responseP = await SavePageDetail(componentKey, {
          data: pageDetailRoute,
          lang: qLang,
        })

        console.log(responseP)

        const response = await CreateContent({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201 && responseP.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}/edit/${resData.data.mainId}`)
              window.location.reload()
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContent: async (payload, pageDetailRoute) => {
      try {
        let responseP = {
          status: 202,
        }
        responseP = await UpdatePageDetail(componentKey, {
          params: {},
          data: pageDetailRoute,
          lang: qLang,
        })

        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 202 && responseP.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/${qLang}/edit`)
              // window.location.reload()
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContentPage: async (payload, pageSettingRoute) => {
      try {
        const responseP = await UpdatePageDetail(componentKey, {
          data: pageSettingRoute,
          lang: qLang,
        })
        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = responseP.data
        if (resData.status == 202 && responseP.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/page/${qLang}/edit`)
              window.location.reload()
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },

    fetchGetCategoryList: async payload => {
      try {
        const response = await SearchContentCate({
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          setCategoryList(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 002",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentById(payload)
    }
    API.fetchGetCategoryList()
  }, [qLang])

  useEffect(() => {
    if (
      ["update", "view"].includes(pageView) &&
      prefillComplete &&
      Object.keys(contentDetail).length > 0
    ) {
      const _pageDetail = API.fetchGetPageDetail(
        componentKey,
        `${contentDetail?.slug}`
      )
      setPageDetail(_pageDetail)
    }
  }, [prefillComplete, contentDetail])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  const mapValues = (list = []) =>
    list.map(item => {
      const newObj = {
        attachmentId: item.attachmentId,
        sequence: item.sequence,
      }
      return newObj
    })

  if (
    !checkScope(`${_routePermission}:create`) ||
    !checkScope(`${_routePermission}:update`) ||
    !checkScope(`${_routePermission}:view`)
  ) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} ${_pageName}`}
            breadcrumbItems={[
              { title: _pageName, link: "" },
              { title: _pageName + " List", link: `/${_routeLink}/${qLang}` },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-cube-alt"></i> Information Box
                          </h5>
                          <CardBody>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="contentName"
                                className="col-md-12 col-form-label"
                              >
                                Project title name
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <Input
                                  id="contentName"
                                  className="form-control"
                                  type="text"
                                  placeholder=""
                                  name="contentName"
                                  onChange={e => {
                                    validation.setFieldValue(
                                      "contentName",
                                      e.target.value
                                    )
                                    validation.setFieldValue(
                                      "contentSeoTitle",
                                      e.target.value
                                    )
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.contentName}
                                  invalid={
                                    validation.touched.contentName &&
                                    validation.errors.contentName
                                      ? true
                                      : false
                                  }
                                  disabled={pageView === "view"}
                                />
                                {validation.touched.contentName &&
                                  validation.errors.contentName && (
                                    <FormFeedback type="invalid">
                                      {validation.errors.contentName}
                                    </FormFeedback>
                                  )}
                              </div>
                              <hr />
                            </Col>

                            <Row>
                              <Col className="col-12 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="page-thumbnail"
                                    label="Image"
                                    required={true}
                                    description="description"
                                    widthSize={576}
                                    heightSize={576}
                                    value={validation.values.thumbnail}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "thumbnail",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue("thumbnail", {})
                                    }}
                                  />
                                  {validation.touched.thumbnail &&
                                    validation.errors.thumbnail && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.thumbnail}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="slug"
                                  className="col-md-12 col-form-label"
                                >
                                  Slug
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="slug"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="slug"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "slug",
                                        slugify(e.target.value)
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.slug}
                                    invalid={
                                      validation.touched.slug &&
                                      validation.errors.slug
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.slug &&
                                    validation.errors.slug && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.slug}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-6 mb-3">
                                <label
                                  htmlFor="titleDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  Title Detail
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="titleDetail"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="titleDetail"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "titleDetail",
                                        e.target.value
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.titleDetail}
                                    invalid={
                                      validation.touched.titleDetail &&
                                      validation.errors.titleDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.titleDetail &&
                                    validation.errors.titleDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.titleDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-6 mb-3">
                                <label
                                  htmlFor="categoryId"
                                  className="col-md-12 col-form-label"
                                >
                                  Category
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="categoryId"
                                    className="form-control"
                                    type="select"
                                    placeholder=""
                                    name="categoryId"
                                    onChange={e => {
                                      console.log("e", e)
                                      validation.setFieldValue(
                                        "categoryId",
                                        e.target.value
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.categoryId}
                                    invalid={
                                      validation.touched.categoryId &&
                                      validation.errors.categoryId
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  >
                                    <option value=""></option>
                                    {categoryList &&
                                      categoryList.map((i, k) => {
                                        return (
                                          <option key={k} value={i.mainId}>
                                            {i.contentName}
                                          </option>
                                        )
                                      })}
                                  </Input>
                                  {validation.touched.categoryId &&
                                    validation.errors.categoryId && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.categoryId}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentShortDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  Top Detail
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentShortDetail"
                                    placeholder=""
                                    name="contentShortDetail"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentShortDetail",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentShortDetail}
                                    invalid={
                                      validation.touched.contentShortDetail &&
                                      validation.errors.contentShortDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentShortDetail &&
                                    validation.errors.contentShortDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentShortDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  Content Detail
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentDetail"
                                    placeholder=""
                                    name="contentDetail"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentDetail",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentDetail}
                                    invalid={
                                      validation.touched.contentDetail &&
                                      validation.errors.contentDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentDetail &&
                                    validation.errors.contentDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              <Col className="col-12 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="page-icon"
                                    label="Icon Show In Sustainability"
                                    required={false}
                                    description="description"
                                    widthSize={200}
                                    heightSize={200}
                                    value={validation.values.icon}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue("icon", value)
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue("icon", {})
                                    }}
                                  />
                                  {validation.touched.icon &&
                                    validation.errors.icon && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.icon}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentShowSustain"
                                  className="col-md-12 col-form-label"
                                >
                                  Content Show In Sustainability
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentShowSustain"
                                    placeholder=""
                                    name="contentShowSustain"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentShowSustain",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentShowSustain}
                                    invalid={
                                      validation.touched.contentShowSustain &&
                                      validation.errors.contentShowSustain
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentShowSustain &&
                                    validation.errors.contentShowSustain && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentShowSustain}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-6 mb-3">
                                {/* {JSON.stringify(validation.values.bannerDesktop)} */}
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="banner-desktop"
                                    label="Banner Desktop"
                                    required={true}
                                    description="description"
                                    widthSize={2160}
                                    heightSize={990}
                                    value={validation.values.bannerDesktop}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerDesktop",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerDesktop",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.bannerDesktop &&
                                    validation.errors.bannerDesktop && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.bannerDesktop}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-6 mb-3">
                                {/* {JSON.stringify(validation.values.bannerMobile)} */}
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageMap"
                                    upload="Image"
                                    prefixName="banner-mobile"
                                    label="Banner Mobile"
                                    required={true}
                                    description="description"
                                    widthSize={540}
                                    heightSize={780}
                                    value={validation.values.bannerMobile}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerMobile",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerMobile",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.bannerMobile &&
                                    validation.errors.bannerMobile && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.bannerMobile}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                              validation.values
                                                .contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${
                                      validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                    }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              <Col className="text-start">
                                <Button
                                  color="danger"
                                  className="btn btn-danger"
                                  onClick={() =>
                                    // /what-we-do/highlight-card-list/:cardId/:lang
                                    navigate(`/${_routeLink}/${qLang}`)
                                  }
                                >
                                  Back
                                </Button>
                              </Col>
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                      <Col className="col-12">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-trending-up"></i> SEO Box
                          </h5>
                          <CardBody>
                            <Row className="">
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Title
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoTitle"
                                    className="form-control"
                                    type="text"
                                    placeholder="Page Title"
                                    name="contentSeoTitle"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentSeoTitle}
                                    invalid={
                                      validation.touched.contentSeoTitle &&
                                      validation.errors.contentSeoTitle
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoTitle &&
                                    validation.errors.contentSeoTitle && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentSeoTitle}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Description
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoDescription"
                                    className="form-control"
                                    type="text"
                                    placeholder="SEO Description"
                                    name="contentSeoDescription"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.contentSeoDescription
                                    }
                                    invalid={
                                      validation.touched
                                        .contentSeoDescription &&
                                      validation.errors.contentSeoDescription
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoDescription &&
                                    validation.errors.contentSeoDescription && (
                                      <FormFeedback type="invalid">
                                        {
                                          validation.errors
                                            .contentSeoDescription
                                        }
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Keywords
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoKeyword"
                                    className="form-control"
                                    type="text"
                                    placeholder="SEO Keywords"
                                    name="contentSeoKeyword"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentSeoKeyword}
                                    invalid={
                                      validation.touched.contentSeoKeyword &&
                                      validation.errors.contentSeoKeyword
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoKeyword &&
                                    validation.errors.contentSeoKeyword && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentSeoKeyword}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(FlagShipProjectDetailTemplate)
